import React, { useCallback } from 'react';
import { message } from 'antd';
import { maxFileSize } from '../../../../../../../../constants/maxFileSize';
import UploadButton from '../../../../../../../../components/UploadButton/UploadButton';
import { addShutdownAttachments } from '../../../../../../features/shutdown';
import { CardButton } from '../../../../../../../../components/Card';
import styles from './UploadBtn.module.scss';

const { useAddShutdonwAttachments } = addShutdownAttachments;

const beforeUpload = (file) => {
  if (file.size > maxFileSize) {
    message.error(`Файл ${file.name} весит больше 15 мб`);
    return false;
  }

  return true;
};

const UploadBtn = ({ shutdownId }) => {
  const { add: addAttachment, loading } = useAddShutdonwAttachments();

  const handleAddAttachment = useCallback(({ file }) => {
    addAttachment({ shutdownId, files: [file] });
  }, []);

  return (
    <UploadButton
      multiple
      showUploadList={false}
      disabled={loading}
      beforeUpload={beforeUpload}
      customRequest={handleAddAttachment}
      className={styles.upload}
      buttonComponent={
        <CardButton
          text="Добавить"
          className={styles.btn}
        />
      }
    />
  );
};

export default UploadBtn;
